module.exports = __webpack_public_path__ + "img/Logo-Eagle.f4b01ca7.png";